import { mergeStyles } from "office-ui-fabric-react";

export const divider = mergeStyles({
    marginTop: 35,
  });


